
import LoginForm from './LoginForm';

const Login = ({...props }) => {
    return (<LoginForm {...props}/>);
};

export default Login;